// Itens de prêmio da Campanha de Vendas 2ª Edição, por classificação — só texto de exibição (nunca R$: a
// visão do vendedor não pode mostrar valor de prêmio, só o item). Vieram de um slide de divulgação da
// campanha, não têm lógica de negócio nem tabela no sistema hoje — se a lista mudar, é aqui que se edita.
// `icone` é um ícone do Material Design (mdi) representando o item — não temos foto real dos produtos, e
// sair buscando imagem na internet pra um sistema real tem risco de direito autoral/produto errado.
export const PREMIOS_CAMPANHA_VENDA_MARGEM = {
  OURO: [
    { nome: '2x Honda Bizz 125 EX', icone: 'mdi-motorbike' },
    { nome: '1x Moto Elétrica', icone: 'mdi-moped-electric' },
  ],
  PRATA: [
    { nome: 'Notebook', icone: 'mdi-laptop' },
    { nome: 'Ar-condicionado Split 9.000 BTUs', icone: 'mdi-air-conditioner' },
    { nome: 'Robô aspirador Xiaomi', icone: 'mdi-robot-vacuum' },
  ],
  BRONZE: [
    { nome: '2x TV de 50"', icone: 'mdi-television' },
    { nome: 'Patinete elétrico', icone: 'mdi-scooter-electric' },
  ],
};

// ordem de progressão das classificações, usada pra montar a "escada" de prêmios e resolver a próxima
// classificação na tela do vendedor
export const ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM = ['NÃO ATINGIU', 'BRONZE', 'PRATA', 'OURO'];
